import { CHANNEL_TYPES, PROVIDER_TYPES } from '@/vars/general'

const REGULAR_MAX_PROVIDERS = new Set([PROVIDER_TYPES.maxBasis, PROVIDER_TYPES.maxDh])
const MAX_BUSINESS_TYPES = new Set([CHANNEL_TYPES.maxBusiness, PROVIDER_TYPES.maxBusiness])

function readTypes(item) {
    return [item.connectorType, item.providerType, item.connector?.providerType, item.channelType]
}

export function isRegularMaxChannel(item) {
    if (!item || typeof item !== 'object') return false
    const types = readTypes(item)
    if (types.some(type => MAX_BUSINESS_TYPES.has(type))) return false
    if (item.connectorType === CHANNEL_TYPES.maxChannel) return true
    return types.some(type => REGULAR_MAX_PROVIDERS.has(type))
}

export function shouldWarnMaxMarketingPriority(item, column) {
    if (column !== 'mailings' && column !== 'custom') return false
    return isRegularMaxChannel(item)
}
